export const COLLECTIONS = {
    USERS: 'halo_users',
    HALOS: 'halos',
    HALO_CUSTOMERS: 'halo_customers',
    HALO_INTERACTIONS: 'halo_interactions',
    HALO_VIDEOS: 'halo_videos',
    GENERATION_COUNT: 'generation_count'
}

export const POLAR_BENEFITS = {
    PLUS: '1f66b688-52a1-474a-9483-890561266e49',
    PRO: 'f8c77672-8005-4c0a-b302-bcc95ba2a8ae'
}

export const POLAR_PRODUCTS = {
    PLUS: '69ed2668-61e5-4b58-9685-109fee48e1f6',
    // PLUS: '363ff19a-9bf9-46fc-9098-5f24180ce389',
    PRO: '03dd587e-3dfc-46df-b127-03e7bc6abe88'
}


export const POLAR_SANDBOX_PRODUCTS = {
    PLUS: 'bedcf5d7-1870-4a25-ac18-4f1ed1c743bd',
    PRO: 'd0a63bd1-409b-4e36-a651-6478d0ae45d8'
}